import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IloginRequestPayload,
  IActionType,
  IMFASessionPayload,
  IMFASessionValidateResponse,
  ILoginResponseNormalized,
  IMFASessionValidatePayload,
  IMFAFallbackPayload,
  IMFAFallbackResponse,
  IMFASessionResponseNormalized, IKeycloakAuthExchangeRequestPayload,
} from "../../interfaces/Index";
import {
  loginApiCall,
  mfaSessionApiCall,
  mfaSessionValidateApiCall,
  mfaSessionFallbackApiCall, validateKeycloakSession
} from "../sources/AuthSource";

export const loginInit = () => ({
  type: actionTypes.LOGIN_INIT,
});

export const loginSuccess = (payload: object | null) => ({
  type: actionTypes.LOGIN_SUCCESS,
  payload,
});

export const loginFail = (error: string | object | null) => ({
  type: actionTypes.LOGIN_FAIL,
  error,
});

export const mfaSessionInit = () => ({
  type: actionTypes.GET_MFA_SESSION_INIT,
});

export const mfaSessionSuccess = (payload: IMFASessionResponseNormalized) => ({
  type: actionTypes.GET_MFA_SESSION_SUCCESS,
  payload,
});

export const mfaSessionFail = (error: string | object | null) => ({
  type: actionTypes.GET_MFA_SESSION_FAIL,
  error,
});

export const validateMfaSessionInit = () => ({
  type: actionTypes.VALIDATE_MFA_SESSION_INIT,
});

export const validateMfaSessionSuccess = (
  payload: IMFASessionValidateResponse | ILoginResponseNormalized
) => ({
  type: actionTypes.VALIDATE_MFA_SESSION_SUCCESS,
  payload,
});

export const validateMfaSessionFail = (error: string | object | null) => ({
  type: actionTypes.VALIDATE_MFA_SESSION_FAIL,
  error,
});

export const mfaFallbackSuccess = (
  payload: IMFAFallbackResponse | ILoginResponseNormalized
) => ({
  type: actionTypes.MFA_FALLBACK_SUCCESS,
  payload,
});

export const MfaFallbackInit = () => ({
  type: actionTypes.MFA_FALLBACK_INIT,
});

export const mfaFallbackFail = (error: string | object | null) => ({
  type: actionTypes.MFA_FALLBACK_FAIL,
  error,
});

// async actions
export const login = (payload: IloginRequestPayload) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(loginInit());
  return loginApiCall(payload)
    .then((authRes: any) => dispatch(loginSuccess(authRes)))
    .catch((e: object | null | string) => dispatch(loginFail(e)));
};

export const getMfaSession = (payload: IMFASessionPayload) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(mfaSessionInit());
  return mfaSessionApiCall(payload)
    .then((mfa: IMFASessionResponseNormalized) => dispatch(mfaSessionSuccess(mfa)))
    .catch((e: object | null | string) => dispatch(mfaSessionFail(e)));
};

export const validateMfaSession = (payload: IMFASessionValidatePayload) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(validateMfaSessionInit());
  return mfaSessionValidateApiCall(payload)
    .then((mfa: IMFASessionValidateResponse | ILoginResponseNormalized) => {
      if ((mfa as IMFASessionValidateResponse).mfaToken) {
        return dispatch(validateMfaSessionSuccess(mfa));
      }
      return dispatch(loginSuccess(mfa as ILoginResponseNormalized));
    })
    .catch((e: object | null | string) => dispatch(validateMfaSessionFail(e)));
};

export const mfaFallbackSession = (payload: IMFAFallbackPayload) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(MfaFallbackInit());
  return mfaSessionFallbackApiCall(payload)
    .then((mfa: IMFAFallbackResponse | ILoginResponseNormalized) => {
      return dispatch(mfaFallbackSuccess(mfa));
    })
    .catch((e: object | null | string) => dispatch(mfaFallbackFail(e)));
};

export const validateKeycloakSessionAction = (payload: IKeycloakAuthExchangeRequestPayload) => (
    dispatch: Dispatch<IActionType>
) => {
  dispatch(validateMfaSessionInit());
  return validateKeycloakSession(payload)
      .then((mfa: IMFASessionValidateResponse | ILoginResponseNormalized | any) => {
        if ((mfa as IMFASessionValidateResponse).mfaToken) {
          return dispatch(validateMfaSessionSuccess(mfa));
        }
        return dispatch(loginSuccess(mfa as ILoginResponseNormalized));
      })
      .catch((e: object | null | string) => dispatch(validateMfaSessionFail(e)));
};